import React, { useEffect, useState } from 'react'
import Iframe from 'react-iframe';
import {  URL_MAP_DEFAULT } from '../../../service/Config';

export default function P301Map({data}) {

    const [sentData, setSentData] = useState({
        contractNo : "",
        branch :""
    })

    useEffect(() => {
        setSentData({
            contractNo : data.contractNo ?data.contractNo:"",
            branch : data.branchCode ?data.branchCode:""
        })

    }, [data])

    return (
        <>
        {
            (sentData.branch !=="")?(
                <Iframe
                    // url={`http://sitdev.dyndns.org:9107/Map301?branch=${sentData.branch}&contractNo=${sentData.contractNo}&token=dev`}
                    url={`${URL_MAP_DEFAULT()}/Map301?branch=${sentData.branch}&contractNo=${sentData.contractNo}&token=dev`}
                    width="100%"
                    height="600"
                    display="initial"
                    position="relative"
                />
            ):('No Data')
        }

        </>
    )
}
